import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import {
  formatPartnerProduct,
  formatPartnerProductDetails,
} from './partnerProgram.format'

export function use(
  client: WbsClient,
  partnerProgram: API['partnerProgram'],
  _api: API,
  defaults: AdapterDefaults
): void {
  // GET /v3/partner-product
  partnerProgram.getPartnerProductsByPageFx.use(
    async ({ page = 0, count = defaults.count || 36, sortBy, sortOrder }) => {
      const products = await payload(
        client.get.api.v3.partnerProduct({
          query: {
            page,
            count,
            'sort-by': sortBy,
            'sort-order': sortOrder,
          },
        })
      )

      return {
        ...products,
        content: products.content.map(formatPartnerProduct),
      }
    }
  )

  // GET /v3/partner-product/{partnerProductId}
  partnerProgram.getPartnerProductFx.use(async ({ partnerProductId }) => {
    const product = await payload(
      client.get.api.v3.partnerProduct(partnerProductId)
    )
    return formatPartnerProductDetails(product)
  })
}
